<template>
  <sea-page title="I miei dati" header="I miei dati">
    <employee-profile
      :fetchData="fetchMyData"
      :reset="reset"
      :data="myData"
    ></employee-profile>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EmployeeProfile from "../components/EmployeeProfile.vue";

export default {
  components: { EmployeeProfile },
  methods: {
    ...mapActions({
      fetchMyData: "employee/fetchProfile",
      reset: "employee/resetProfile",
    }),
  },
  computed: {
    ...mapGetters({
      myData: "employee/profile",
    }),
  },
};
</script>

<style>
</style>
